import { BaseError } from '@dynamic-labs-sdk/client';

export class PhantomMissingEncryptionParamsError extends BaseError {
  constructor() {
    super({
      cause: null,
      code: 'phantom_missing_encryption_params_error',
      docsUrl: null,
      name: 'PhantomMissingEncryptionParamsError',
      shortMessage:
        'Phantom redirect response is missing required encryption parameters (phantomPublicKey, data, or nonce).',
    });
  }
}
